/**
 * TrendModa — Sosyal Kanıt (GERÇEK veri / Google Apps Script + Sheets)
 *
 * - Ürün sayfası görüntülenmesini ve sepete-ekleme olaylarını anonim loglar.
 * - Ürün kartlarındaki "X inceliyor / X sepetinde" rozetlerini GERÇEK sayılarla doldurur.
 * - Veri yoksa (0) ilgili rozet/metrik gizlenir — asla uydurma sayı göstermez.
 *
 * Yapılandırma: window.TM_SOCIAL_PROOF = { enabled, endpoint } (theme.liquid'de set edilir)
 * Gizlilik: yalnızca anonim oturum kimliği + ürün id'si gönderilir, KVKK kapsamında PII yok.
 */
(function () {
  'use strict';

  var CFG = window.TM_SOCIAL_PROOF || {};
  if (!CFG.enabled || !CFG.endpoint) return;
  var ENDPOINT = CFG.endpoint;

  var PRODUCT_REFRESH_MS = 15 * 1000;
  var countsRequest = null;
  var productRefreshTimer = null;

  var VIEW_THROTTLE_MS = 30 * 60 * 1000; // aynı oturum/ürün için 30 dk'da bir view logla
  var COUNTS_CACHE_MS = 60 * 1000;       // sayıları 60 sn cache'le
  var recentAtc = {};                    // çift sayımı engelle

  // --- Anonim oturum kimliği ---
  function sessionId() {
    try {
      var k = 'tm_sp_sid', v = localStorage.getItem(k);
      if (!v) {
        v = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
        localStorage.setItem(k, v);
      }
      return v;
    } catch (_) { return 'anon'; }
  }

  // --- Olay gönder (yaz, yanıt okunmaz → no-cors) ---
  function logEvent(type, productId) {
    if (!productId) return;
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({
          action: 'event', type: type,
          productId: String(productId), sessionId: sessionId(), ts: Date.now()
        })
      }).catch(function () {});
    } catch (_) {}
  }

  function logViewOncePerWindow(productId) {
    try {
      var k = 'tm_sp_v_' + productId, last = parseInt(localStorage.getItem(k) || '0', 10);
      if (Date.now() - last < VIEW_THROTTLE_MS) return;
      localStorage.setItem(k, String(Date.now()));
    } catch (_) {}
    logEvent('view', productId);
  }

  function logAtc(productId) {
    if (!productId) return;
    if (recentAtc[productId] && Date.now() - recentAtc[productId] < 5000) return;
    recentAtc[productId] = Date.now();
    logEvent('atc', productId);
  }

  // --- Rozetleri doldur ---
  function collectIds() {
    var ids = {};
    document.querySelectorAll('conversion-urgency[data-product-id], [data-tm-sp][data-product-id], [data-tm-product-proof][data-product-id]').forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      if (id) ids[id] = true;
    });
    return Object.keys(ids);
  }

  function proofIcon(type) {
    if (type === 'cart') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.8 7.2h12.9l-1.2 7.1a2 2 0 0 1-2 1.7H9.2a2 2 0 0 1-2-1.6L5.4 3.8H2.8"/><circle cx="9.5" cy="19.5" r="1.2"/><circle cx="17" cy="19.5" r="1.2"/></svg>';
    }
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.7-6.2 9.5-6.2 9.5 6.2 9.5 6.2-3.7 6.2-9.5 6.2S2.5 12 2.5 12Z"/><circle cx="12" cy="12" r="2.8"/></svg>';
  }

  function proofItem(type, value, copy, compactCopy) {
    return '<span class="tm-sp-item tm-sp-item--' + type + '">' +
      '<span class="tm-sp-item__icon">' + proofIcon(type) + '</span>' +
      '<span class="tm-sp-item__copy"><strong>' + value + '</strong> ' +
      '<span class="tm-sp-item__copy-long">' + copy + '</span>' +
      '<span class="tm-sp-item__copy-short">' + compactCopy + '</span></span>' +
      '</span>';
  }

  function applyChip(el, v, c) {
    var items = [];
    var labels = [];
    if (v >= 1) {
      items.push(proofItem('view', v, 'kişi inceliyor', 'bakıyor'));
      labels.push(v + ' kişi bu ürünü inceliyor');
    }
    if (c >= 1) {
      items.push(proofItem('cart', c, 'kişi sepete ekledi', 'sepette'));
      labels.push(c + ' kişi bu ürünü sepete ekledi');
    }
    if (!items.length) {
      el.hidden = true;
      el.innerHTML = '';
      el.classList.remove('ty-card__sp-chip--rotating');
      el.removeAttribute('aria-label');
      el.removeAttribute('title');
      return;
    }
    el.innerHTML = '<span class="tm-sp-track" aria-hidden="true">' + items.join('') + '</span>';
    el.classList.toggle('ty-card__sp-chip--rotating', items.length > 1);
    el.setAttribute('aria-label', labels.join('. '));
    el.setAttribute('title', labels.join(' · '));
    el.hidden = false;
  }

  function applyCounts(el, v, c) {
    var viewSlides = [], cartSlides = [];
    el.querySelectorAll('.tm-conversion-slide').forEach(function (s) {
      if (s.querySelector('.view-count')) viewSlides.push(s);
      if (s.querySelector('.cart-count')) cartSlides.push(s);
    });
    el.querySelectorAll('.view-count').forEach(function (x) { x.textContent = v; });
    el.querySelectorAll('.cart-count').forEach(function (x) { x.textContent = c; });

    var showV = v >= 1, showC = c >= 1;
    if (!showV && !showC) { el.style.display = 'none'; return; }
    el.style.display = '';
    viewSlides.forEach(function (s) { s.style.display = showV ? '' : 'none'; });
    cartSlides.forEach(function (s) { s.style.display = showC ? '' : 'none'; });
    // Tek metrik kaldıysa kaydırma animasyonunu durdur (boş kare olmasın)
    if (showV && showC) el.classList.remove('tm-cu--single');
    else el.classList.add('tm-cu--single');
  }

  function productProofItem(type, value, copy) {
    return '<span class="product__live-proof-item product__live-proof-item--' + type + '">' +
      '<span class="product__live-proof-icon">' + proofIcon(type) + '</span>' +
      '<span><strong>' + value + '</strong> ' + copy + '</span>' +
      '</span>';
  }

  function applyProductProof(el, v, c) {
    if (el.dataset.viewCount === String(v) && el.dataset.cartCount === String(c)) return;
    el.dataset.viewCount = String(v);
    el.dataset.cartCount = String(c);
    var items = [];
    var labels = [];
    var viewCopy = el.getAttribute('data-view-copy') || 'kişi şu an inceliyor';
    var cartCopy = el.getAttribute('data-cart-copy') || 'kişi sepete ekledi';
    if (v >= 1) {
      items.push(productProofItem('view', v, viewCopy));
      labels.push(v + ' ' + viewCopy);
    }
    if (c >= 1) {
      items.push(productProofItem('cart', c, cartCopy));
      labels.push(c + ' ' + cartCopy);
    }
    if (!items.length) {
      el.hidden = true;
      el.innerHTML = '';
      el.removeAttribute('aria-label');
      return;
    }
    el.innerHTML = items.join('<span class="product__live-proof-divider" aria-hidden="true"></span>');
    el.setAttribute('aria-label', labels.join('. '));
    el.hidden = false;
  }

  function fillBadges(forceRefresh) {
    var ids = collectIds();
    if (!ids.length) return Promise.resolve();

    // Cache kontrolü
    var cache = {};
    try { cache = JSON.parse(sessionStorage.getItem('tm_sp_counts') || '{}'); } catch (_) {}
    var now = Date.now();
    var missing = ids.filter(function (id) {
      return forceRefresh || !cache[id] || (now - cache[id]._at > COUNTS_CACHE_MS);
    });

    function render() {
      document.querySelectorAll('conversion-urgency[data-product-id]').forEach(function (el) {
        var id = el.getAttribute('data-product-id');
        var d = cache[id];
        if (d) applyCounts(el, d.v | 0, d.c | 0);
      });
      document.querySelectorAll('[data-tm-sp][data-product-id]').forEach(function (el) {
        var id = el.getAttribute('data-product-id');
        var d = cache[id];
        if (d) applyChip(el, d.v | 0, d.c | 0);
      });
      document.querySelectorAll('[data-tm-product-proof][data-product-id]').forEach(function (el) {
        var id = el.getAttribute('data-product-id');
        var d = cache[id];
        if (d) applyProductProof(el, d.v | 0, d.c | 0);
      });
    }

    if (!missing.length) {
      render();
      return Promise.resolve();
    }

    if (countsRequest) return countsRequest;

    var url = ENDPOINT + (ENDPOINT.indexOf('?') > -1 ? '&' : '?') +
      'action=counts&ids=' + encodeURIComponent(missing.join(',')) +
      '&_tm=' + now;
    var controller = new AbortController();
    var requestTimeout = window.setTimeout(function () { controller.abort(); }, 10000);
    countsRequest = fetch(url, { cache: 'no-store', credentials: 'omit', signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('Social proof response failed');
        return r.json();
      })
      .then(function (res) {
        if (res && res.data) {
          Object.keys(res.data).forEach(function (id) {
            var d = res.data[id] || {};
            cache[id] = { v: d.v | 0, c: d.c | 0, s: d.s | 0, _at: now };
          });
          try { sessionStorage.setItem('tm_sp_counts', JSON.stringify(cache)); } catch (_) {}
        }
        render();
      })
      .catch(function () { render(); })
      .finally(function () {
        window.clearTimeout(requestTimeout);
        countsRequest = null;
      });
    return countsRequest;
  }

  function refreshProductProof(delay) {
    window.setTimeout(function () {
      if (document.visibilityState !== 'hidden') fillBadges(true);
    }, delay || 0);
  }

  function startProductRefresh() {
    if (productRefreshTimer) return;
    productRefreshTimer = window.setInterval(function () {
      if (document.visibilityState === 'visible') fillBadges(true);
    }, PRODUCT_REFRESH_MS);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') fillBadges(true);
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) fillBadges(true);
    });
  }

  // --- Ürün sayfası: view logla + ATC yakala ---
  function initProductPage() {
    var proof = document.querySelector('[data-tm-product-proof][data-product-id]');
    var pid = (window.tmProduct && window.tmProduct.id) ? window.tmProduct.id :
      (proof ? proof.getAttribute('data-product-id') : null);
    if (pid) {
      logViewOncePerWindow(pid);
      startProductRefresh();
      refreshProductProof(1800);
    }

    // ATC: pub/sub (mobil) — cartData.product_id öncelikli
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
          var id = (e && e.cartData && e.cartData.product_id) || pid;
          logAtc(id);
          refreshProductProof(1200);
          refreshProductProof(4500);
        });
      } catch (_) {}
    }
  }

  function init() {
    initProductPage();
    fillBadges();
  }

  function scheduleInit() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(init, { timeout: 1500 });
    } else {
      setTimeout(init, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit, { once: true });
  } else {
    scheduleInit();
  }

  // Sonsuz kaydırma / filtre sonrası yeni kartları doldur
  document.addEventListener('collection:reloaded', fillBadges);
})();
